import { type ReactNode } from 'react';

import { Tooltip, TooltipContent, TooltipTitle, TooltipTrigger } from '@/components/Tooltip';

type StatFieldItemProps = {
  children: ReactNode;
  tooltip?: string;
  tooltipTitle?: string;
};

const StatFieldItem = ({ children, tooltip, tooltipTitle }: StatFieldItemProps) => {
  const className = 'max-w-full truncate *:max-w-full *:truncate';

  if (!tooltip) {
    return <div className={className}>{children}</div>;
  }

  return (
    <Tooltip disableHoverablePopup>
      <TooltipTrigger render={<div className={className}>{children}</div>} />
      <TooltipContent className="flex-col items-start">
        {tooltipTitle && <TooltipTitle>{tooltipTitle}</TooltipTitle>}
        {tooltip}
      </TooltipContent>
    </Tooltip>
  );
};

export default StatFieldItem;
